import { dictionariesState } from './dictionariesSlice';

export const initialState: dictionariesState = {
  loading: 'idle',
  data: [],
};
